import { useEffect, useMemo, useState } from "react";
import Popup from '../../components/message-form/pop-up-form'
import { Link } from 'react-router-dom'
import { STATUS_MAP } from "../../../_metronic/helpers/StatusBackgroundColorHelpers";

const renderVendorSelect = (
    assignedToValue: string,
    handleAssignedToChange: (e: any) => void,
    results: any[],
    buttonClass: string,
    submitAssign: () => void
) => (
    <div>
        <select
            className='form-select form-select-sm form-select-solid'
            value={assignedToValue}
            onChange={handleAssignedToChange}
        >
            <option value='0'>Choose Vendor</option>
            {results?.map((item: any) =>
                item.searcher_SCOMP_Company?.length > 1 ? (
                    <option key={item.searcher_SCOMP_ID} value={item.searcher_SCOMP_Code}>
                        {item.searcher_SCOMP_Company}
                    </option>
                ) : null
            )}
        </select>
        <button className={buttonClass} onClick={submitAssign}>Submit</button>
    </div>
);

const renderVendorLink = (row: any, companyIcon: any, linkStyle: any) => (
    <div style={{ display: 'flex', alignItems: 'center' }}>
        <Link
            to="/vendorprofile"
            state={{ searchCompanyId: row.assignedTo.id, companyIcon, tab: 'Profile' }}
            className="text-decoration-underline"
            style={linkStyle}
        >
            {row.assignedTo?.name}
        </Link>
    </div>
);

const renderAssignedTo = (
    row: any,
    selectProps: {
        assignedToValue: string;
        handleAssignedToChange: (e: any) => void;
        results: any[];
        buttonClass: string;
        submitAssign: () => void;
    },
    linkProps: {
        companyIcon: any;
        linkStyle: any;
    }
) => {
    if (row.tab === 'received') {
        return renderVendorSelect(selectProps.assignedToValue, selectProps.handleAssignedToChange, selectProps.results, selectProps.buttonClass, selectProps.submitAssign);
    }
    if (row.assignedTo) {
        return renderVendorLink(row, linkProps.companyIcon, linkProps.linkStyle);
    }
    return <span>N/A</span>;
}

const RenderAssignmentRow = ({
    params,
    fileDetails,
    results,
    updateSearchCompany,
    showPopup,
    setShowPopup,
}: any) => {
    const row = params?.row ?? params;

    const [assignedToValue, setAssignedToValue] = useState('0');
    const [firstload, setFirstload] = useState(false);
    const [buttonClass, setButtonClass] = useState('btn btn-secondary disabled');
    const canEditInProgress =
        row.tab === 'progress' &&
        row.transaction_county_search_status === 'open'
    const companyIcon = useMemo(() => {
        const companyId = row?.assignedTo?.id;
        const files = fileDetails?.find((fd: any) => fd.company_id === companyId)?.res;

        if (!companyId || !files?.length) return STATUS_MAP.grey;

        let latestEO: any = null;
        const foundStatuses = new Set<string>();

        files.forEach((file: any) => {
            const { complianceName, status, fileExpirationDate } = file;
            if (complianceName === 'E&O') {
                if (!latestEO || new Date(fileExpirationDate) > new Date(latestEO.fileExpirationDate)) {
                    latestEO = file;
                }
            } else if (['red', 'orange', 'green'].includes(status)) {
                foundStatuses.add(status);
            }
        });

        if (latestEO?.status) foundStatuses.add(latestEO.status);

        if (foundStatuses.has('red')) return STATUS_MAP.red;
        if (foundStatuses.has('orange')) return STATUS_MAP.orange;
        if (foundStatuses.has('green')) return STATUS_MAP.green;

        return STATUS_MAP.grey;
    }, [row?.assignedTo?.id, fileDetails]);

    const linkColor = companyIcon === STATUS_MAP.red ? 'red' : '#0089e5';
    const linkStyle = { color: linkColor };

    useEffect(() => {
        if (params) setFirstload(true);
    }, [params]);

    useEffect(() => {
        if (results && row?.assignedTo && firstload) {
            const searchCode = results.find((r: any) => r.searcher_SCOMP_ID === row.assignedTo.id);
            if (searchCode) {
                setAssignedToValue(searchCode.searcher_SCOMP_Code);
                setButtonClass('btn btn-primary');
            }
        }
    }, [results, firstload]);

    const handleAssignedToChange = (event: any) => {
        const selectedValue = event.target.value;
        setAssignedToValue(selectedValue);
        setButtonClass(selectedValue === '0' ? 'btn btn-secondary disabled' : 'btn btn-primary');
    };

    const submitAssign = () => {
        if (assignedToValue !== '0') {
            const searchCompany = results.find(
                (r: any) => r.searcher_SCOMP_Code === assignedToValue
            )?.searcher_SCOMP_ID;
            const orderId = Number.parseInt(`${row.orderID}`);
            updateSearchCompany(orderId, searchCompany).then(() => setShowPopup(true));
        }
    };

    const handleClose = () => {
        setShowPopup(false);
        window.location.reload();
    }
    return (
        <div>
            {renderAssignedTo(
                row,
                {
                    assignedToValue,
                    handleAssignedToChange,
                    results,
                    buttonClass,
                    submitAssign
                },
                {
                    companyIcon,
                    linkStyle
                }
            )}
            {showPopup && (
                <Popup message='Update has been made successfully' onClose={handleClose} />
            )}
        </div>
    );
};

export { RenderAssignmentRow };